<template>
  <div class="user-center__editPhone">
    <div>
      <span class="user-center__editPhone-back" @click="back">
        <svg-icon class-name="login-back" icon-class="login_back" />
      </span>
      <span class="user-center__editPhone-title">
        {{ $t("bindOrEdit") }}
        {{ panelType === "mobile" ? $t("mobileNo") : $t("email") }}
      </span>
    </div>
    <div id="formWrap" class="form-wrap">
      <div ref="form" class="form">
        <div
          v-if="panelType === 'mobile'"
          class="form-item mobile"
          prop="mobile"
          :class="{
            'is-error': error.mobile.isError,
            'is-validate': error.mobile.isError === false
          }"
        >
          <input
            v-model="form.mobile"
            autocomplete="off"
            @blur="onInputBlur('mobile')"
          />
          <div :class="{ blur: form.mobile }" class="form-label">
            {{ $t("mobileNo") }}
          </div>
          <div class="form-input-placeholder">
            {{ $t("input") }}{{ $t("mobileNo") }}
          </div>
          <div class="form-item__error">
            {{ error.mobile.message }}
          </div>
        </div>
        <div
          v-if="panelType === 'email'"
          class="form-item mobile"
          prop="email"
          :class="{
            'is-error': error.email.isError,
            'is-validate': error.email.isError === false
          }"
        >
          <input
            v-model="form.email"
            autocomplete="off"
            @blur="onInputBlur('email')"
          />
          <div :class="{ blur: form.email }" class="form-label">
            {{ $t("email") }}
          </div>
          <div class="form-input-placeholder">
            {{ $t("input") }}{{ $t("email") }}
          </div>
          <div class="form-item__error">
            {{ error.email.message }}
          </div>
        </div>
        <div
          class="form-item vertifycode"
          prop="vertifycode"
          :class="{
            'is-error': error.vertifycode.isError,
            'is-validate': error.vertifycode.isError === false
          }"
        >
          <input
            v-model="form.vertifycode"
            autocomplete="off"
            maxlength="4"
            @blur="onInputBlur('vertifycode')"
          />
          <div :class="{ blur: form.vertifycode }" class="form-label">
            {{ $t("vertifyCode") }}
          </div>
          <div
            v-if="status === 'pending'"
            class="vertify-status vertify-status--pending"
          >
            {{ timer }}s
          </div>
          <div
            v-else-if="
              error.mobile.isError === false || error.email.isError === false
            "
            class="vertify-status vertify-status--empty"
            @click="startTimer"
          >
            {{ $t("get") }}{{ $t("vertifyCode") }}
          </div>
          <div class="form-input-placeholder">
            {{ $t("input") }}{{ $t("vertifyCode") }}
          </div>
          <div class="form-item__error">
            {{ error.vertifycode.message }}
          </div>
        </div>
        <div class="form-item login">
          <iw-button
            type="primary"
            size="large"
            style="width: 120px;"
            @click="save()"
          >
            {{ $t("confirm") }}
          </iw-button>
          <iw-button size="large" style="width: 120px;" @click="cancel()">
            {{ $t("cancel") }}
          </iw-button>
        </div>
      </div>
    </div>
    <transition v-if="visible" transition-name="fade">
      <div class="message-box">
        <span class="message">{{ message }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
import Validator from "@/utils/validate";
import {
  bindPhone,
  sendBindCode,
  bindEmail,
  sendBindCodeEmail
} from "@/api/user";
const messageChannel = {
  // 触发渠道
  PC: 1, // IW PC
  MOBILE: 2 // IW 移动
};
const messageEvent = {
  // 消息事件
  LOGIN: 1, // 登录验证
  BIND: 2, // 绑定验证
  MONITOR: 3 // 系统监控
};

export default {
  props: {
    panelType: {
      type: String,
      default: "mobile"
    }
  },
  data() {
    return {
      message: "绑定成功",
      visible: false,
      loading: {},
      form: {
        mobile: "",
        email: "",
        vertifycode: ""
      },
      rules: {
        mobile: [
          { required: true, message: this.$t("input") + this.$t("mobileNo") },
          { type: "mobile", message: this.$t("mobileMessage") }
        ],
        email: [
          { required: true, message: this.$t("input") + this.$t("email") },
          { type: "email", message: this.$t("emailMessage") }
        ],
        vertifycode: [
          {
            required: true,
            message: this.$t("input") + this.$t("vertifyCode")
          },
          {
            validator: (value, message) => {
              if (!/^\d{4}$/.test(value)) {
                return message;
              }
            },
            message: this.$t("vertifyMessage")
          }
        ]
      },
      error: {
        mobile: {
          isError: "",
          message: ""
        },
        email: {
          isError: "",
          message: ""
        },
        vertifycode: {
          isError: "",
          message: ""
        }
      },
      timer: "",
      status: "" // pending（进行中）
    };
  },
  mounted() {},
  methods: {
    back() {
      this.$emit("changeShowPanel", { showPanel: 1 });
    },

    /* 点击获取验证码 */
    startTimer() {
      const { panelType } = this;
      if (this.validateForm(panelType) !== true) {
        return false;
      }
      this.status = "pending";
      this.timer = 120;
      const t = setInterval(() => {
        this.timer -= 1;
        if (this.timer === 0) {
          window.clearInterval(t);
          this.status = "";
        }
      }, 1000);

      /* 发送短信获取验证码 */
      const interfaceMethod =
        panelType === "mobile" ? sendBindCode : sendBindCodeEmail;
      interfaceMethod({
        to: this.form[panelType],
        messageChannel: messageChannel["PC"],
        messageEvent: messageEvent["BIND"]
      })
        .then(res => {
          const { status } = res.data || {};
          if (status.status === 0) {
            //
          } else {
            this.error.vertifycode.isError = true;
            this.error.vertifycode.message = status.msg2Client;
          }
        })
        .catch(() => {});
    },
    /* 点击获取验证码 */
    onInputBlur(name) {
      this.validateForm(name);
    },
    /* 表单验证 */
    validateForm(name = "") {
      const validator = new Validator(this, "form");
      const { valid, error } = validator.validate(name);
      this.error = { ...this.error, ...error };
      return valid;
    },
    /* 提交表单 */
    save() {
      if (this.validateForm() !== true) {
        return false;
      }
      this.loading = this.$loading({
        lock: true,
        target: document.querySelector("#formWrap")
      });
      const interfaceMethod =
        this.panelType === "mobile" ? bindPhone : bindEmail;
      interfaceMethod({
        emalAd: this.form.email,
        phonNo: this.form.mobile,
        randomCode: this.form.vertifycode
      })
        .then(response => {
          const { status } = response.data || {};
          this.visible = true;
          if (status.status === 0) {
            this.message = this.$t("bindSuccess");
            this.$store.dispatch("user/getUserInfo").then(() => {
              this.back();
            });
          } else {
            this.message = this.$t("bindFail");
            this.error.vertifycode.isError = true;
            this.error.vertifycode.message = status.msg2Client;
          }
        })
        .catch(response => {
          console.log(response);
          this.message = this.$t("bindFail");
        })
        .finally(() => {
          this.loading.close();
          setTimeout(() => {
            this.visible = false;
          }, 3000);
        });
    },
    cancel() {
      this.form = {
        mobile: "",
        email: "",
        vertifycode: ""
      };
      this.back();
    }
  }
};
</script>

<style lang="scss" scoped>
.user-center__editPhone {
  width: 100%;
  height: 100%;
  position: relative;

  .user-center__editPhone-back {
    cursor: pointer;
    display: inline-block;
    .login-back {
      width: 22px;
      height: 22px;
    }
  }

  .user-center__editPhone-title {
    font-size: 24px;
    // color: $--color-text-primary;
    line-height: 24px;
  }

  .message-box {
    position: absolute;
    top: 50%;
    width: 100%;
    text-align: center;
    .message {
      opacity: 0.7;
      background: #000000;
      border-radius: 2px;
      display: inline-block;
      color: #fff;
      padding: 9px 20px;
      line-height: 14px;
    }
  }
}
@import "~@/styles/_handle.scss";
.form-wrap {
  width: 100%;
  margin-top: 70px;
  .form {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .form-item {
      position: relative;
      margin-bottom: 10px;
      width: 100%;
      input {
        width: 100%;
        height: 60px;
        line-height: 60px;
        font-size: 16px;
        padding: 26px 0px 14px 0;
        box-sizing: border-box;
        box-shadow: inset 0 -1px 0 0 #e3e3e7;
        &:not([disabled]):focus {
          box-shadow: inset 0 -2px 0 0 #4f6ef2;
        }
        &:not([disabled]):focus ~ .form-input-placeholder {
          display: none;
        }
      }
      .iw-button {
        width: 100%;
        padding: 17px;
        border-radius: 0;
      }
      .form-label {
        // color: $--color-text-primary;
        pointer-events: none;
        font-size: 14px;
        position: absolute;
        top: 0;
        left: 2px;
        line-height: 14px;
        width: 200px;
        z-index: 1;
        &.blur {
          color: #bbc0cd;
        }
      }
      .vertify-status {
        @include color("primary");
        font-size: 14px;
        position: absolute;
        bottom: 0;
        right: 0;
        text-align: center;
        width: 100px;
        height: 56px;
        line-height: 56px;
        &.vertify-status--empty {
          cursor: pointer;
        }
      }
      .form-input-placeholder {
        pointer-events: none;
        color: #dfe0e6;
        font-size: 14px;
        line-height: 18px;
        position: absolute;
        top: 28px;
        left: 2px;
      }
      .form-item__error {
        display: none;
        font-size: 14px;
        line-height: 14px;
        color: #ff5656;
        position: absolute;
        padding-top: 0;
        top: 0;
        left: 2px;
      }
      &.vertifycode {
        margin-bottom: 40px;
        input {
          padding: 26px 100px 14px 0;
        }
      }
      &.login {
        margin-bottom: 8px;
      }
      &.is-error {
        input {
          box-shadow: inset 0 -2px 0 0 #ff5656;
        }
        .form-label {
          display: none;
        }
        .form-item__error {
          display: block;
        }
        .form-input-placeholder {
          display: none;
        }
      }
      &.is-validate {
        .form-input-placeholder {
          display: none;
        }
      }
    }
  }
}
</style>
